// Recovered compiled webpack factory 71350. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n, a, o, i;
  r.d(t, { li: () => b, mG: () => v });
  var s = r(26552),
    l = r(61571),
    u = r(43275),
    c = r(16649),
    f = r(43115),
    d = r(66941),
    p = r(49636),
    h = r(28385),
    _ = r(2332),
    m = r(3055),
    g = r(35868),
    y = r(87624);
  function v(e, t, r, v, b, E) {
    var R, P;
    let { normalizeDepth: S = 3, normalizeMaxBreadth: O = 1e3 } = e,
      T = {
        ...t,
        event_id: t.event_id || r.event_id || (0, h.eJ)(),
        timestamp: t.timestamp || (0, y.lu)(),
      },
      w = r.integrations || e.integrations.map((e) => e.name);
    ((function (e, t) {
      let { environment: r, release: n, dist: a, maxValueLength: o } = t;
      ((e.environment = e.environment || r || s.U),
        !e.release && n && (e.release = n),
        !e.dist && a && (e.dist = a));
      let i = e.request;
      (i?.url && o && (i.url = (0, g.xv)(i.url, o)),
        o &&
          e.exception?.values?.forEach((e) => {
            e.value && (e.value = (0, g.xv)(e.value, o));
          }));
    })(T, e),
      (R = T),
      (P = w).length > 0 &&
        ((R.sdk = R.sdk || {}), (R.sdk.integrations = [...(R.sdk.integrations || []), ...P])),
      b && b.emit("applyFrameMetadata", t),
      void 0 === t.type &&
        (function (e, t) {
          let r = (function (e) {
            let t = p.O._sentryDebugIds,
              r = p.O._debugIds;
            if (!t && !r) return {};
            let s = t ? Object.keys(t) : [],
              l = r ? Object.keys(r) : [];
            if (i && s.length === a && l.length === o) return i;
            ((a = s.length), (o = l.length), (i = {}), n || (n = {}));
            let u = (t, r) => {
              for (let a of t) {
                let t = r[a],
                  o = n?.[a];
                if (o && i && t) ((i[o[0]] = t), n && (n[a] = [o[0], t]));
                else if (t) {
                  let r = e(a);
                  for (let e = r.length - 1; e >= 0; e--) {
                    let o = r[e],
                      s = o?.filename;
                    if (s && i && n) {
                      ((i[s] = t), (n[a] = [s, t]));
                      break;
                    }
                  }
                }
              }
            };
            return (t && u(s, t), r && u(l, r), i);
          })(t);
          e.exception?.values?.forEach((e) => {
            e.stacktrace?.frames?.forEach((e) => {
              e.filename && (e.debug_id = r[e.filename]);
            });
          });
        })(T, e.stackParser));
    let j = (function (e, t) {
      if (!t) return e;
      let r = e ? e.clone() : new d.H();
      return (r.update(t), r);
    })(v, r.captureContext);
    r.mechanism && (0, h.M6)(T, r.mechanism);
    let x = b ? b.getEventProcessors() : [],
      A = (0, m.Om)(E, j),
      C = [...(r.attachments || []), ...A.attachments];
    (C.length && (r.attachments = C), (0, m.e2)(T, A));
    let M = [...x, ...A.eventProcessors];
    return (
      r.data && !0 === r.data.__sentry__
        ? (0, f.XW)(T)
        : (function (e, t, r, n = 0) {
            try {
              let a = (function e(t, r, n, a) {
                let o = n[a];
                if (!t || !o) return t;
                let i = o({ ...t }, r);
                return (l.T &&
                  null === i &&
                  u.Yz.log(`Event processor "${o.id || "?"}" dropped event`),
                (0, c.Qg)(i))
                  ? i.then((t) => e(t, r, n, a + 1))
                  : e(i, r, n, a + 1);
              })(t, r, e, n);
              return (0, c.Qg)(a) ? a : (0, f.XW)(a);
            } catch (e) {
              return (0, f.xg)(e);
            }
          })(M, T, r)
    ).then((e) =>
      (e &&
        (function (e) {
          let t = {};
          if (
            (e.exception?.values?.forEach((e) => {
              e.stacktrace?.frames?.forEach((e) => {
                e.debug_id &&
                  (e.abs_path
                    ? (t[e.abs_path] = e.debug_id)
                    : e.filename && (t[e.filename] = e.debug_id),
                  delete e.debug_id);
              });
            }),
            0 === Object.keys(t).length)
          )
            return;
          ((e.debug_meta = e.debug_meta || {}), (e.debug_meta.images = e.debug_meta.images || []));
          let r = e.debug_meta.images;
          Object.entries(t).forEach(([e, t]) => {
            r.push({ type: "sourcemap", code_file: e, debug_id: t });
          });
        })(e),
      "number" == typeof S && S > 0)
        ? (function (e, t, r) {
            if (!e) return null;
            let n = {
              ...e,
              ...(e.breadcrumbs && {
                breadcrumbs: e.breadcrumbs.map((e) => ({
                  ...e,
                  ...(e.data && { data: (0, _.S8)(e.data, t, r) }),
                })),
              }),
              ...(e.user && { user: (0, _.S8)(e.user, t, r) }),
              ...(e.contexts && { contexts: (0, _.S8)(e.contexts, t, r) }),
              ...(e.extra && { extra: (0, _.S8)(e.extra, t, r) }),
            };
            return (
              e.contexts?.trace &&
                n.contexts &&
                ((n.contexts.trace = e.contexts.trace),
                e.contexts.trace.data &&
                  (n.contexts.trace.data = (0, _.S8)(e.contexts.trace.data, t, r))),
              e.spans &&
                (n.spans = e.spans.map((e) => ({
                  ...e,
                  ...(e.data && { data: (0, _.S8)(e.data, t, r) }),
                }))),
              e.contexts?.flags &&
                n.contexts &&
                (n.contexts.flags = (0, _.S8)(e.contexts.flags, 3, r)),
              n
            );
          })(e, S, O)
        : e,
    );
  }
  function b(e) {
    if (e) {
      var t;
      return (t = e) instanceof d.H ||
        "function" == typeof t ||
        Object.keys(e).some((e) => E.includes(e))
        ? { captureContext: e }
        : e;
    }
  }
  let E = ["user", "level", "extra", "contexts", "tags", "fingerprint", "propagationContext"];
}
